<template>
  <div :class="classes.join(' ')">
      <strong :class="`has-text-${titleVariant}`">
        <font-awesome-icon icon="circle-info" class="mr-2" />
        {{ title || 'Warning'}}:
      </strong>
      <slot>{{ message }}</slot>
    </div>
</template>

<script>
export default {
  props: {
    title: String,
    message: String,
    flash: Boolean,
    variant: String,
    titleVariant: String,
  },
  computed: {
    classes () {
      let classes = ['notification', `is-${this.variant || 'warning'}`]
      if (this.flash) classes = [ ...classes, 'animate__flash', 'animate__animated' ]
      return classes
    }
  }
}
</script>